<template>
  <div>
    <b-button @click="showAutoPnModal" style="width: 9.5rem" variant="primary">Automate PN</b-button>
    <b-modal centered ok-title="submit" @ok="autoPnRequestPreConfirm"
             ref="AutoPnModal" title="Automate PN" @cancel="cancelModal"
             button-size="sm">
      <div class="header-col pb-4">
        <div>Reference SKU ID</div>
        <div>
          <b-form-select class="min-w-10" v-model="refSkuTmp" :options="standardSkuList"></b-form-select>
        </div>

      </div>
      <div class="header-col pb-4">
        <div>Customized Model</div>
        <div>
          <!--<b-form-select class="min-w-10" v-model="product_code" :options="product_code_options" @change="updateCatagory"
                 value-field="product_code" text-field="prj_name">
  </b-form-select>-->
          <gtc-multi-select v-model="product_code_dict" key-field="product_code" text-field="prj_name" @change="updateCatagory"
                            :options="product_code_options" select-class="min-w-10" :multiple="false"></gtc-multi-select>
        </div>
      </div>
      <div class="header-col pb-4">
        <div>Customized Category</div>
        <div><b-form-select class="min-w-10" v-model="category_obj" :options=category_options @change="updateAutoPnObj"></b-form-select></div>
      </div>
      <div class="header-col pb-4"
           v-if="refSkuTmp != null &&
                 product_code_dict != null &&
                 category_obj != null">
        <div>Reference MPS PN</div>
        <b-form-group>
          <b-form-input class="min-w-10 max-w-10" list="mps-pn-list" v-model="autoPnObj.ref_mps_pn" placeholder="請選擇或輸入" @change="detectPnChanged(autoPnObj.ref_mps_pn, 'mps')"></b-form-input>

          <datalist id="mps-pn-list">
            <option v-for="mpsPn in mpsPnList" :key="mpsPn" :value="mpsPn"></option>
          </datalist>
        </b-form-group>
        <b-button class="ml-2" @click="pnChanged(autoPnObj.ref_mps_pn, 'mps')" variant="primary" size="sm">Get Desc</b-button>
        <!--<b-form-select v-model="ref_pn_obj" :options="standardPnList" @blur="pnChanged"></b-form-select>-->

      </div>
      <div class="header-col pb-4" v-if="refSkuTmp != null &&
       product_code_dict != null &&
       category_obj != null">
        <div>Reference SHIP PN</div>
        <!--<b-form-select v-model="ref_pn_obj" :options="standardPnList" @blur="pnChanged"></b-form-select>-->
        <b-form-group>
          <b-form-input class="min-w-10 max-w-10" list="ship-pn-list" v-model="autoPnObj.ref_ship_pn" placeholder="請選擇或輸入" @change="detectPnChanged(autoPnObj.ref_ship_pn, 'ship')"></b-form-input>

          <datalist id="ship-pn-list">
            <option v-for="shipPn in shipPnList" :key="shipPn" :value="shipPn"></option>
          </datalist>
        </b-form-group>
        <b-button class="ml-2" @click="pnChanged(autoPnObj.ref_ship_pn, 'ship')" variant="primary" size="sm">Get Desc</b-button>
      </div>

      <div class="row mb-4" v-if="_.get(autoPnObj, 'mps_to_component', null) != null && _.get(autoPnObj, 'ref_mps_pn', null) != null">
        <div class="col-12">
          <div>MPS PN:</div>
          <!-- 子項目，縮排 -->
          <ul>
            <li>
              <div class="d-flex align-items-center">
                <b-form-textarea v-model="autoPnObj.mps_item_desc" class="ml-1" no-resize max-rows="10"></b-form-textarea>
              </div>
            </li>
            <li class="ml-4 text-danger" v-if="_.get(autoPnObj, 'mps_from_component', null) != null">DEL {{_.get(autoPnObj, 'mps_from_component', null)}}</li>
            <li class="ml-4 text-success">ADD {{_.get(autoPnObj, 'mps_to_component', null)}} {{_.get(autoPnObj, 'mps_component_desc', null)}}</li>
          </ul>
        </div>
        <div class="col-12" v-if="_.get(autoPnObj, 'taa_flag', false) != false">
          <!--<div class="header-col pb-4">
            <div>Country Code</div>
            <div>
              <gtc-multi-select v-model="country_code_dict" key-field="code" text-field="codeText" @change="updateAutoPnObj"
                                :options="country_code_options" select-class="min-w-10" :multiple="false"></gtc-multi-select>
            </div>
          </div>-->
          <div>SHIP PN :</div>
          <!-- 子項目，縮排 -->
          <!--<div class="ml-4">
    <b-form-textarea v-model="autoPnObj.ship_item_desc" class="mb-1 d-inline-block w-50"  no-resize max-rows="10"></b-form-textarea>
    <span class="ml-2 text-danger">DEL {{_.get(autoPnObj, 'ship_from_component', null)}}</span>
    <span class="ml-2 text-success">ADD {{_.get(autoPnObj, 'ship_to_component', null)}} {{_.get(autoPnObj, 'ship_component_desc', null)}}</span>
  </div>-->
          <ul>
            <li>
              <div class="d-flex align-items-center">
                <b-form-textarea v-model="autoPnObj.ship_item_desc" class="ml-1" no-resize max-rows="10"></b-form-textarea>
              </div>
            </li>
            <li class="ml-4 text-danger" v-if="_.get(autoPnObj, 'ship_from_component', null) != null">DEL {{_.get(autoPnObj, 'ship_from_component', null)}}</li>
            <li class="ml-4 text-success">ADD {{_.get(autoPnObj, 'ship_to_component', null)}} {{_.get(autoPnObj, 'ship_component_desc', null)}}</li>
          </ul>
        </div>
      </div>
      <!--<div class="table-responsive">
      <b-table :items="items" :fields="fields"></b-table>
    </div>-->

    </b-modal>
    <b-modal centered ok-title="Yes, Automate the PN" @ok="autoPnRequestSubmit"
             cancel-title="Cancel"
             ok-variant="primary"
             title-class="primary"
             ref="AutoPnConfirmModal" title="Auto Pn Confirm"
             button-size="sm">
      <div>
        <p><b>Are you sure want to trigger this PN Automation?</b></p>
      </div>

    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'auto-pn-trigger', // AutoNreTrigger
    /*autopilot- sku*/
    props: {
      prop_sfdcProducts: {
        default: []
      },
      prop_user: {
        default: null
      },
      prop_ftie_id: {
        default: null
      },
      prop_detail_id: {
        default: null
      },
      prop_model_name: {
        default: null
      },
      prop_customer_name:{
        default: null
      },
    },
    data: function () {
      return {
        //  Customization Type	CUSTOMIZATION_TYPE	Varchar2(60)	必要	AUTOPILOT	客製類別,固定選項, 共五種
        //        Item Description	ITEM_DESC	Varchar2(300)	必要		品名
        //Reference MPS PN	REFERENCE_MPS_PN	Varchar2(20)	必要	5262GA02008B
        //Reference Ship PN	REFERENCE_SHIP_PN	Varchar2(20)	非必要		有勾TAA才要
        //Ticket Number	TICKET_NUMBER	Varchar2(20)	非必要
        //Data Source	DATA_SOURCE	Varchar2(36)	必要	FTIE	來源系統名稱(FTIE)
        //TAA Flag	TAA_FLAG	Varchar2(1)	必要	Y	Y or N
        //Created by	CREATED_BY	Varchar2(16)	必要	G5691	工號
        //Creation Date	CREATION_DATE	Date	必要		FITE寫入日期
        //From component(MPS)	FROM_COMPONENT_MPS	Varchar2(20)	非必要		若是Autopilot則為空白
        //To Component(MPS)	TO_COMPONENT_MPS	Varchar2(20)	必要		要更換或新增的料(例.autopilot料號)
        //        From component(SHIP)	FROM_COMPONENT_SHIP	Varchar2(20)	非必要		有勾TAA才要
        //To Component(SHIP)	TO_COMPONENT_SHIP	Varchar2(20)	非必要		有勾TAA才要
        //Model	MODEL	Varchar2(36)	非必要
        //Product Code	PRODUCT_CODE	Varchar2(36)	必要	GA61C	用來編料號使用
        product_code_options: [
          { prj_code: "GA01", product_code: "GA01C", prj_name: "Test Project 1" },
          { prj_code: "GA02", product_code: "GA02C", prj_name: "Test Project 2" },
        ],
        country_code_options: [
          { code: "",   codeText: "" },
          { code: "AE", codeText: "AE" },
          { code: "AN", codeText: "AN" },
          { code: "AU", codeText: "AU" },
          { code: "FR", codeText: "FR" },
          { code: "GB", codeText: "GB" },
          { code: "IL", codeText: "IL" },
          { code: "IN", codeText: "IN" },
          { code: "JP", codeText: "JP" },
          { code: "LV", codeText: "LV" },
          { code: "MX", codeText: "MX" },
          { code: "MY", codeText: "MY" },
          { code: "NL", codeText: "NL" },
          { code: "RO", codeText: "RO" },
          { code: "SE", codeText: "SE" },
          { code: "SG", codeText: "SG" },
          { code: "TW", codeText: "TW" },
          { code: "US", codeText: "US" },
          { code: "VN", codeText: "VN" },
        ],
        category_raw_data: [
          //{ prj_code: "GB73", category: "Autopilot", sub_category: "", mps_from_component: null, mps_to_component: "Autopilot pn", ship_from_component: null, ship_to_component: null, },
          //{ prj_code: "GB73", category: "SSD", sub_category: "", mps_from_component: "SSD from pn", mps_to_component: "SSD to pn", ship_from_component: "SSD taa from pn", ship_to_component: "SSD taa to pn", },
          //{ prj_code: "GA02", category: "LTSC", sub_category: "", mps_from_component: "LTSC from pn", mps_to_component: "LTSC from pn", ship_from_component: null, ship_to_component: null, },
          //{ prj_code: "GA02", category: "B件non-logo", sub_category: "", mps_from_component: "B件non-logo pn", mps_to_component: "B件non-logo pn", ship_from_component: null, ship_to_component: null, }
        ],
        autoPnObj: {
          category: "", mps_item_desc: "", ship_item_desc: "", ref_mps_pn: null, ref_ship_pn: null, ftie_id: null, taa_flag: false, model: null, product_code: null,
          mps_from_component: null, mps_to_component: null, mps_component_desc: null, ship_from_component: null, ship_to_component: null, ship_component_desc: null,
          country_code: null
        },
        //{ mps_pn: null, ship_pn: null }
        ref_pn_obj: { mps_pn: null, ship_pn: null },
        category_obj: null,
        product_code_dict: null,
        country_code_dict: null,
        items: [
          {
            CUSTOMIZATION_TYPE: "Autoiplot", ITEM_DESC: "5262XXXXXXXXX ", REFERENCE_MPS_PN: "A PN", REFERENCE_SHIP_PN: null,
            TAA_FLAG: "N", FROM_COMPONENT_MPS :null, TO_COMPONENT_MPS: "Autopilot component pn",
            FROM_COMPONENT_SHIP: null, TO_COMPONENT_SHIP: null, MODEL: "S410G5", PRODUCT_CODE: "GA61C",
            PROCESS_RESULT: "In process", ERROR_MESSAGE: null, PROCESS_START_DATE: "2025-05-05", PROCESS_END_DATE: null,
            NEW_MPS_PN: null, NEW_SHIP_PN:null
          }
        ],
        fields: [
          { key: 'CUSTOMIZATION_TYPE', label: 'TYPE', thClass: 'text-nowrap ' },
          { key: 'ITEM_DESC', label: 'ITEM_DESC', thClass: 'text-nowrap ' },
          { key: 'REFERENCE_MPS_PN', label: 'REF_MPS_PN', thClass: 'text-nowrap ' },
          { key: 'REFERENCE_SHIP_PN', label: 'REF_SHIP_PN', thClass: 'text-nowrap ' },
          { key: 'TAA_FLAG', label: 'TAA', thClass: 'text-nowrap ' },
          { key: 'NEW_MPS_PN', label: 'NEW_MPS_PN', thClass: 'text-nowrap ' },
          { key: 'NEW_SHIP_PN', label: 'NEW_SHIP_PN', thClass: 'text-nowrap ' },
          //{ key: 'FROM_COMPONENT_MPS', label: 'FROM_COMPONENT_MPS', thClass: 'text-nowrap ' },
          //{ key: 'TO_COMPONENT_MPS', label: 'TO_COMPONENT_MPS', thClass: 'text-nowrap ' },
          //{ key: 'FROM_COMPONENT_SHIP', label: 'FROM_COMPONENT_SHIP', thClass: 'text-nowrap ' },
          //{ key: 'TO_COMPONENT_SHIP', label: 'TO_COMPONENT_SHIP', thClass: 'text-nowrap ' },
          { key: 'MODEL', label: 'MODEL', thClass: 'text-nowrap ' },
          { key: 'PRODUCT_CODE', label: 'PRODUCT_CODE', thClass: 'text-nowrap ' },
          { key: 'PROCESS_RESULT', label: 'PROCESS_RESULT', thClass: 'text-nowrap ' },
          { key: 'ERROR_MESSAGE', label: 'ERROR_MESSAGE', thClass: 'text-nowrap ' },
          //{ key: 'PROCESS_START_DATE', label: 'PROCESS_START_DATE', thClass: 'text-nowrap ' },
          //{ key: 'PROCESS_END_DATE', label: 'PROCESS_END_DATE', thClass: 'text-nowrap ' },
        ],
        refSkuTmp: null,
        selectedShipPn: null,
        selectedMpsPn: null
      }
    },

    computed: {
      standardSkuList() {
        let self = this;
        let tempList = _.uniq(_.map(self.prop_sfdcProducts, (product) => product.standard_sku_id));

        return _.filter(tempList, item => { return item != null; });
      },
      mpsPnList() {
        let self = this;
        let filterList = _.filter(self.prop_sfdcProducts, item => { return item.standard_sku_id == self.refSkuTmp && (item.std_pn_set !=null && item.std_pn_set[0].mps_pn != null); });
        let tempList = _.uniq(_.map(filterList, (product) => product.std_pn_set[0].mps_pn));
        return tempList;
      },
      shipPnList() {
        let self = this;
        let filterList = _.filter(self.prop_sfdcProducts, item => { return item.standard_sku_id == self.refSkuTmp && (item.std_pn_set != null && item.std_pn_set[0].ship_pn != null); });
        let tempList = _.uniq(_.map(filterList, (product) => product.std_pn_set[0].ship_pn));
        return tempList;
      },
      category_options() {
        let self = this;
        let product_code = _.get(self.product_code_dict, 'product_code', null)
        let filter_list = _.filter(self.category_raw_data, item => { return item.product_code == product_code; });
        let mapList = _.uniq(_.map(filter_list, (item) => ({ value: item, text: item.category })));
        if (product_code){
          const item = {product_code: product_code, category: "AUTOPILOT", sub_category: "",
           mps_from_component: null, mps_to_component: "242GA82C0001", mps_component_desc: "TF1-LABEL;MSFT Autopilot registered,[NULL],for all models",
           ship_from_component: null, ship_to_component: "242GA82C0001", ship_component_desc: "TF1-LABEL;MSFT Autopilot registered,[NULL],for all models" };
          mapList.unshift({ value: item, text: "AUTOPILOT" });
        }
        return mapList;
      },
    },

    created() {
      let self = this;
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      //#region -- Auto Nre sku id --
      showAutoPnModal() {
        let self = this;
        self.getProductCodeList();
        self.getAutoPnCategory();
        self.$refs['AutoPnModal'].show();

      },
      getProductCodeList() {
        let self = this;
        let urlFetch = `${self.$root.baseUrl}/auto-pn/product/all/`;
        eventHub.$emit('loading', true);
        self.$axios
          .post(urlFetch)
          .then(resRead => {
            //console.log(resRead);
            if (_.get(resRead, 'status', 0) !== 200) return;
            let data = resRead.data;
            self.product_code_options = data.product_code_list;
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            const result = _.find(self.product_code_options, item => item.prj_name.includes(self.prop_model_name))
            if (result) {
              self.product_code_dict = result;
            }
            self.product_code_options.unshift({ prj_code: null, product_code: null, prj_name: null });
          });
      },
      getAutoPnCategory(bvModalEvt) {
        let self = this;
        //let urlFetch = `${self.$root.baseUrl}/nre/sf-currency/`;
        //eventHub.$emit('loading', true);
        //self.$axios
        //  .post(urlFetch)
        //  .then(resRead => {
        //    //console.log(resRead);
        //    if (_.get(resRead, 'status', 0) !== 200) return;
        //    let data = resRead.data;
        //    self.sfCurrency = data.sf_currency;
        //  })
        //  .finally(() => {
        //    eventHub.$emit('loading', false);
        //  });
      },
      detectPnChanged(pn, category) {
        let self = this;
        if (category == 'mps') {
          self.autoPnObj.mps_item_desc = null;
        } else if (category == 'ship') {
          self.autoPnObj.taa_flag = false;
          self.autoPnObj.ship_item_desc = null;
        }
      },
      pnChanged(pn, category) {
        let self = this;
        self.getPnDesc(pn, category);
      },
      getPnDesc(pn, category) {
        let self = this;
        let urlFetch = `${self.$root.baseUrl}/auto-pn/pn/desc/`;
        eventHub.$emit('loading', true);
         let requestData = {
          pn: pn,
        };
        self.$axios
          .post(urlFetch, requestData)
          .then(resRead => {
            //console.log(resRead);
            if (_.get(resRead, 'status', 0) !== 200) return;
            let data = resRead.data;
            self.updateAutoPnObj()
            if (self.category_obj) {
              let custom_category = _.get(self.category_obj, 'category', null)
              let pn_desc = ""
              let replace_desc = data.pn_desc.replace(self.prop_model_name, self.autoPnObj.model+ " ");
              if (custom_category) {
                if (custom_category =='AUTOPILOT') {
                  pn_desc = `${replace_desc} ${self.prop_customer_name}, #${self.prop_ftie_id},autopilot only, AutoPN`
                }
              }
              if (category == 'mps') {
                self.autoPnObj.mps_item_desc = pn_desc;
              } else if (category == 'ship' && self.autoPnObj.taa_flag===true) {
                self.autoPnObj.ship_item_desc = pn_desc;
              }
            } 
            
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      cancelModal(bvModalEvt) {
        let self = this;
        self.autoPnObj= {
          category: "", mps_item_desc: "", ship_item_desc: "", ref_mps_pn: null, ref_ship_pn: null, ftie_id: null, taa_flag: false, model: null, product_code: null,
          mps_from_component: null, mps_to_component: null, mps_component_desc: null, ship_from_component: null, ship_to_component: null, ship_component_desc: null,
          sku_id: null, country_code: null};
        self.ref_pn_obj= { mps_pn: null, ship_pn: null };
        self.category_obj= null;
        self.product_code_dict = null;
        //self.country_code_dict = null;
        self.refSkuTmp = null;
        self.selectedShipPn = null;
        self.selectedMpsPn= null;
        self.$nextTick(() => {
          self.$refs['AutoPnModal'].hide();
        });
      },
      updateCatagory() {
        let self = this;
        self.category_obj = null;
        self.updateAutoPnObj()
      },
      updateAutoPnObj() {
        let self = this;
        let category = _.get(self.category_obj, 'category', null)
        let mps_from_component = _.get(self.category_obj, 'mps_from_component', null)
        let mps_to_component = _.get(self.category_obj, 'mps_to_component', null)
        let mps_component_desc = _.get(self.category_obj, 'mps_component_desc', null)
        let ship_from_component = _.get(self.category_obj, 'ship_from_component', null)
        let ship_to_component = _.get(self.category_obj, 'ship_to_component', null)
        let ship_component_desc = _.get(self.category_obj, 'ship_component_desc', null)
        let taa_flag = false;
        if (self.autoPnObj.ref_ship_pn && self.autoPnObj.ref_ship_pn != self.autoPnObj.ref_mps_pn) {
          taa_flag = true
        }
        self.autoPnObj.category = category;
        //self.autoPnObj.ref_mps_pn = self.selectedMpsPn;
        self.autoPnObj.ftie_id = self.prop_ftie_id;
        self.autoPnObj.taa_flag = taa_flag;
        let prj_name = _.get(self.product_code_dict, 'prj_name', null);
        let product_code = _.get(self.product_code_dict, 'product_code', null);
        self.autoPnObj.product_code = product_code; 
        self.autoPnObj.model = prj_name;
        //let country_code = _.get(self.country_code_dict, 'code', null)
        //self.autoPnObj.country_code = country_code;
        self.autoPnObj.mps_from_component = mps_from_component;
        self.autoPnObj.mps_to_component = mps_to_component;
        self.autoPnObj.mps_component_desc = mps_component_desc;
        if (self.autoPnObj.taa_flag===true) {
          //self.autoPnObj.ref_ship_pn = self.selectedShipPn;
          self.autoPnObj.ship_from_component = ship_from_component;
          self.autoPnObj.ship_to_component = ship_to_component;
          self.autoPnObj.ship_component_desc = ship_component_desc;
        }
        self.autoPnObj.sku_id = self.refSkuTmp;
      },
      autoPnRequestSubmit(bvModalEvt) {
        bvModalEvt.preventDefault();
        let self = this;
        self.$nextTick(() => {
          self.$refs['AutoPnConfirmModal'].hide();
        })
        let urlFetch = `${self.$root.baseUrl}/auto-pn/submit/`;
        let requestData = {
          username: self.prop_user,
          autoPnObj: self.autoPnObj
        };
        eventHub.$emit('loading', true);
        self.$axios
          .post(urlFetch, requestData)
          .then(resRead => {
            //console.log(resRead);
            if (_.get(resRead, 'status', 0) !== 200) return;
            let data = resRead.data;
            if (data.insert_success) {
              self.$message.info('auto-pn success!');
              self.$emit('done')
            } else {
              self.$message.error(_.get(resRead, 'description', "auto-pn error"), 'Error');
            }

          })
          .finally(() => {
           
            self.$nextTick(() => {
              self.$refs['AutoPnModal'].hide();
            });
            eventHub.$emit('loading', false);
          });
      },
      autoPnRequestPreConfirm(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        if (!(self.autoPnObj.ftie_id)) {
          self.$message.warning('Missing FTIE!!', 'Empty FTIE');
          return false;
        }
        if (!(self.autoPnObj.ref_mps_pn && self.autoPnObj.mps_to_component && self.autoPnObj.mps_component_desc && self.autoPnObj.mps_item_desc)) {
          self.$message.warning('Missing required Mps pn related info!!', 'Mps pn info missing');
          return false;
        }
        if (self.autoPnObj.ref_ship_pn && self.autoPnObj.ref_ship_pn != self.autoPnObj.ref_mps_pn) {
          if (!(self.autoPnObj.ref_ship_pn && self.autoPnObj.ship_to_component
            && self.autoPnObj.ship_component_desc && self.autoPnObj.ship_item_desc)) {
            self.$message.warning('Missing required Ship pn related info!!', 'Ship Pn info Missing');
            return false;
          }
        }
        self.$refs['AutoPnConfirmModal'].show();
      },
      //#endregion
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auto-pn/AutoPnTrigger.vue